import { connect } from 'react-redux';
import { AppState } from '../../../../../../types/store';
import { actions as ModalActions } from '@wix/da-shared-react/pkg/Modals';

import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../../../selectors/users';

export default connect(
  (state: AppState) => ({
    isOwner: isCurrentUserProfileOwner(state),
    username: getProfileOwnerUser(state).username,
  }),
  (dispatch, ownProps) => ({
    openSubmitPostPopup: () =>
      dispatch(
        ModalActions.pushModal(ownProps.CTAButtonModalType, {
          wrapInPopup: false,
        })
      ),
  })
);
